export const handleStylesOnSubmit = () => {
    const addBtn = document.querySelector(".js-add2cart");
    if (!addBtn) return;

    const cartIcon = document.querySelector(".baskets");

    addBtn.addEventListener("click", function () {
        addBtn.classList.add("submitting");
        cartIcon.classList.add("submitting");

        setTimeout(() => {
            addBtn.classList.remove("submitting");
            cartIcon.classList.remove("submitting");
        }, 500);

        // return false
    });
};
